export const getIdFromSlug = (slug: string): number => parseInt(slug.split('-').pop(), 10);
